import type { DeckRating } from '@/types/qbot';

export type RatingLabelKey = 'godly' | 'great' | 'good' | 'fair' | 'weak';

/**
 * Mean of the five axes.
 *
 * `/decks/check` returns the five axes but never the aggregate — QBot computes
 * it at render time, in two places, with the same formula (`deckCheckCard.ts`
 * and the `deckcheck` bot handler). Mirrored here so the TMA prints the same
 * number as the bot instead of inventing its own.
 */
export function overallRating(r: DeckRating): number {
  return (r.attack + r.defense + r.synergy + r.versatility + r.balance) / 5;
}

/**
 * Mirror of QBot's `getRatingLabel` (shared/services/decks/deckRating.ts) —
 * thresholds 9 / 7 / 5 / 3.
 *
 * Returns a key rather than the label: QBot's strings are hardcoded English
 * and this surface is bilingual, so the words live in the `cr` locale files.
 */
export function ratingLabelKey(score: number): RatingLabelKey {
  if (score >= 9) return 'godly';
  if (score >= 7) return 'great';
  if (score >= 5) return 'good';
  if (score >= 3) return 'fair';
  return 'weak';
}

/** Text colour for a 0-10 score. Same breakpoints as <RatingBar />. */
export function ratingToneClass(score: number): string {
  if (score >= 8) return 'text-emerald-400';
  if (score >= 6) return 'text-lime-400';
  if (score >= 4) return 'text-amber-400';
  return 'text-rose-400';
}
